import { DateTime } from 'luxon'

  const seconds = 1000
  const minutes = 60 * seconds
  const hours = 60 * minutes
  const days = 24 * hours

  const dateString = 'd LLL yyyy'
  const timeString = 'h:mma ZZZZ'
  const axesLimitsString = 'LLL d, yyyy'

export default {
  data: () => ({
    dates: {},
    DateTime,
  }),
  computed: {
    hoverText () {
      return {
        startDate: this.formatDatePickerDate(this.dates.startDate),
        startTime: this.formatDatePickerTime(this.dates.startDate),
        endDate: this.formatDatePickerDate(this.dates.endDate),
        endTime: this.formatDatePickerTime(this.dates.endDate),
      }
    },
    datePickerText () {
      const start = DateTime.fromJSDate(this.dates.startDate)
      const end = DateTime.fromJSDate(this.dates.endDate)
      const defaultText = `${start.toFormat(axesLimitsString)} - ${end.toFormat(axesLimitsString)}`
      const leeway = 5 * minutes
      const endDateIsNow = Math.abs(end.diffNow().values.milliseconds) < leeway
      if (endDateIsNow) {
        const startEndDifference = end.diff(start)
        switch (startEndDifference.values.milliseconds) {
          case 30 * minutes: return 'LAST 30 MINUTES'
          case hours: return 'LAST 1 HOUR'
          case 3 * hours: return 'LAST 3 HOURS'
          case days: return 'LAST 24 HOURS'
          case 3 * days: return 'LAST 3 DAYS'
          case 7 * days: return 'LAST 7 DAYS'
          case 100 * days: return 'ALL TIME'
          default: return defaultText
        }
      } else return defaultText
    },
  },
  created () {
    this.initializeDates()
  },
  filters: {
    formatAxesLimit (date) {
      return DateTime.fromJSDate(date).toFormat(axesLimitsString)
    },
  },
  methods: {
    initializeDates () {
      const defaultNumDays = this.history ? 100 : 1
      this.dates.startDate = new Date(Date.now() - defaultNumDays * days)
      this.dates.endDate = new Date()
    },
    formatDatePickerDate (date) {
      return DateTime.fromJSDate(date).toFormat(dateString)
    },
    formatDatePickerTime (date) {
      return DateTime.fromJSDate(date).toFormat(timeString)
    },
  },
}
